import React, { useEffect, useMemo } from "react";
import { Box, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { func, string } from "prop-types";

export const PasswordValidator = (props: any) => {
  // Destructure specific props to avoid dependency issues
  const { password: propPassword = "", handleIsValid } = props;

  // Calculate validation results using useMemo for performance
  const isAtLeast8Chars = useMemo(
    () => propPassword.length >= 8,
    [propPassword],
  );
  const hasCapitalLetter = useMemo(
    () => /[A-Z]/.test(propPassword),
    [propPassword],
  );
  const hasSmallLetter = useMemo(
    () => /[a-z]/.test(propPassword),
    [propPassword],
  );

  // Calculate overall validity using useMemo
  const isValid = useMemo(() => {
    return isAtLeast8Chars && hasCapitalLetter && hasSmallLetter;
  }, [isAtLeast8Chars, hasCapitalLetter, hasSmallLetter]);

  useEffect(() => {
    if (typeof handleIsValid === "function") {
      handleIsValid(isValid);
    }
  }, [isValid, handleIsValid]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-start",
      }}
    >
      <Box sx={{ mt: 2 }}>
        <Typography
          // variant="body1"
          sx={{
            color: isAtLeast8Chars ? "success.main" : "grey.400",
            display: "flex",
          }}
        >
          <CheckIcon fontSize="small" />
          At least 8 characters
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: hasCapitalLetter ? "success.main" : "grey.400",
            display: "flex",
          }}
        >
          <CheckIcon fontSize="small" />
          At least one capital character
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: hasSmallLetter ? "success.main" : "grey.400",
            display: "flex",
          }}
        >
          <CheckIcon fontSize="small" />
          At least one small character
        </Typography>
      </Box>
    </Box>
  );
};

PasswordValidator.propTypes = {
  handleIsValid: func.isRequired,
  password: string.isRequired,
};
